import { Component } from '@angular/core';

@Component({
  selector: 'spl-ui-badge',
  imports: [],
  templateUrl: './badge.html',
  styleUrl: './badge.scss',
})
export class SplUiBadge {}
